/* eslint-disable prettier/prettier */
import ArrowDown from './arrow-down.svg'
import ArrowLeft from './arrow-left.svg'
import ArrowRight from './arrow-right.svg'
import ArrowUp from './arrow-up.svg'
import BrandColor from './brand-color.svg'
import BrandWhatsapp from './brand-whatsapp.svg'
import Brand from './brand.svg'
import Check1 from './check-1.svg'
import Check from './check.svg'
import Close from './close.svg'
import SingleNeutralActions from './single-neutral-actions.svg'
import SocialFacebook from './social-facebook.svg'
import SocialInstagram from './social-instagram.svg'
import SocialLinkedin from './social-linkedin.svg'
import SocialSpotify from './social-spotify.svg'
import SocialTwitter from './social-twitter.svg'
import SocialYoutube from './social-youtube.svg'

const vectors = {
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'brand-color': BrandColor,
  'brand-whatsapp': BrandWhatsapp,
  'brand': Brand,
  'check-1': Check1,
  'check': Check,
  'close': Close,
  'single-neutral-actions': SingleNeutralActions,
  'social-facebook': SocialFacebook,
  'social-instagram': SocialInstagram,
  'social-linkedin': SocialLinkedin,
  'social-spotify': SocialSpotify,
  'social-twitter': SocialTwitter,
  'social-youtube': SocialYoutube,
}

export type VectorsProps = keyof typeof vectors

export default vectors